import React from "react"
import OrderNotes from "./OrderNotes.jsx"
import {
    beginShipmentNotesEditing,
    hasShipmentNotesChanges,
    prepareShipmentNotesForSave,
    shipmentNotesFromApi,
} from "./shipmentNotes.js"

export default function ShipmentOrderNotes({
    notes,
    onSave = async (_nextNotes) => {},
    onStartEdit = () => true,
    helperText = "",
    placeholder = "",
}) {
    return (
        <OrderNotes
            title="Shipment Notes"
            notes={notes ?? ""}
            helperText={helperText}
            placeholder={placeholder}
            normalizeNotes={shipmentNotesFromApi}
            notesHaveChanges={hasShipmentNotesChanges}
            prepareForSave={prepareShipmentNotesForSave}
            beginEditing={beginShipmentNotesEditing}
            onStartEdit={onStartEdit}
            onSave={onSave}
        />
    )
}
